var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2C11.25 2.41421 11.5858 2.75 12 2.75C12.4142 2.75 12.75 2.41421 12.75 2V1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5905C15 17.8184 15.4602 17.1351 16.0867 16.6838C17.8512 15.4129 19 13.3406 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.3406 6.14878 15.4129 7.91327 16.6838C8.53977 17.1351 9 17.8184 9 18.5905V19C9 19.5523 9.44772 20 10 20H14C14.5523 20 15 19.5523 15 19V18.5905Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 22C9.25 21.5858 9.58579 21.25 10 21.25H14C14.4142 21.25 14.75 21.5858 14.75 22C14.75 22.4142 14.4142 22.75 14 22.75H10C9.58579 22.75 9.25 22.4142 9.25 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75216 3.25238C5.04505 2.95949 5.51992 2.95949 5.81282 3.25238L6.51992 3.95949C6.81282 4.25238 6.81282 4.72726 6.51992 5.02015C6.22703 5.31305 5.75216 5.31305 5.45926 5.02015L4.75216 4.31305C4.45926 4.02015 4.45926 3.54528 4.75216 3.25238Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1872 3.2519C18.4801 2.959 18.9549 2.959 19.2478 3.2519C19.5407 3.54479 19.5407 4.01966 19.2478 4.31256L18.5407 5.01966C18.2478 5.31256 17.773 5.31256 17.4801 5.01966C17.1872 4.72677 17.1872 4.2519 17.4801 3.959L18.1872 3.2519Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7498 10.5C1.7498 10.9142 2.08559 11.25 2.4998 11.25H3.4998C3.91402 11.25 4.2498 10.9142 4.2498 10.5C4.2498 10.0858 3.91402 9.75 3.4998 9.75H2.4998C2.08559 9.75 1.7498 10.0858 1.7498 10.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 11.25C20.086 11.25 19.7502 10.9142 19.7502 10.5C19.7502 10.0858 20.086 9.75 20.5002 9.75H21.5002C21.9144 9.75 22.2502 10.0858 22.2502 10.5C22.2502 10.9142 21.9144 11.25 21.5002 11.25H20.5002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvention);
export default __webpack_public_path__ + "static/media/invention.bccaa2d921ad57fcf45e1b517ffd7251.svg";
export { ForwardRef as ReactComponent };